import React from 'react';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {IButtonBaseProps} from "@ui/buttons/buttonCustom/types";
import {sx} from './sx'
import {classNames} from "@helpers/classNames";

interface IProps extends IButtonBaseProps {
    variant?: 'primary' | 'secondary',
}

const PrimaryButtonSingleVoyage = ({
                                       onClick,
                                       children,
                                       fullWidth,
                                       sx: sxProps = {},
                                       startIcon,
                                       endIcon,
                                       variant='primary',
                                       disabled,
                                       className,
                                   }: IProps) => {
    return (
        <ButtonCustom
            sx={{
                ...sx.root,
                ...sxProps,
            }}
            className={classNames(variant,className)}
            fullWidth={fullWidth}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            variant={'contained'}
            disabled={disabled}
            size={'small'}
        >
            {children}
        </ButtonCustom>
    );
};

export default PrimaryButtonSingleVoyage;